/**
 * segmentStatusPlugin — TipTap ProseMirror decoration plugin.
 *
 * Applies CSS class decorations to segment ranges based on their status:
 * - 'stale'      → .segment-stale  (amber left-border)
 * - 'generating' → .segment-generating  (opacity + pulse cursor)
 *
 * Spec 08 §10.6
 */

import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

export const segmentStatusPluginKey = new PluginKey('segmentStatus')

export const segmentStatusPlugin = new Plugin({
  key: segmentStatusPluginKey,
  props: {
    decorations(state) {
      const decorations: Decoration[] = []
      const { doc } = state

      // Collect all segmentHeading positions + statuses in a single O(N) pass
      const headings: Array<{ pos: number; status: string }> = []
      doc.descendants((node, pos) => {
        if (node.type.name === 'segmentHeading') {
          headings.push({ pos, status: node.attrs['status'] as string })
        }
      })

      // Compute boundaries from sorted positions — no nested doc traversal needed
      for (let i = 0; i < headings.length; i++) {
        const heading = headings[i]
        if (!heading) continue
        const { pos, status } = heading
        if (status !== 'stale' && status !== 'generating') continue

        const nextHeading = headings[i + 1]
        const segmentEnd = nextHeading ? nextHeading.pos : doc.content.size
        decorations.push(
          Decoration.node(pos, segmentEnd, {
            class: status === 'stale' ? 'segment-stale' : 'segment-generating',
          })
        )
      }

      return DecorationSet.create(doc, decorations)
    },
  },
})
